




















import {Vue, Component, Prop, Watch} from 'vue-property-decorator'
import Utils from '@/utils'
import collect from 'collect.js'
import Window from '@/components/proxy/Window/Window.vue'
import WindowItem from '@/components/proxy/Window/WindowItem.vue'
import Button from '@/components/Button.vue'
import CustomIcon from '@/components/CustomIcon.vue'

export interface Notification {
  id: number | string,
  text: string,
  icon: string
  color?: string
  dismissable?: boolean
  read: boolean
}

@Component({
  components: {
    CustomIcon,
    Button,
    WindowItem,
    Window,
    Layout: Utils.loadComponent('proxy/Layout'),
    FloatingNotificationChip: Utils.loadComponent('FloatingNotificationChip'),
  },
  name: 'FloatingNotificationWrapper',
})
export default class FloatingNotificationWrapper extends Vue {

  public page: number = 0
  public fakeIndexCounter: number = 4

  public notificationList: Notification[] = []

  public get pages() {
    return this.paginatedNotificationList.length
  }

  public get paginatedNotificationList() {
    return collect(this.notificationList).chunk(4).toArray()
  }

  protected remove(val: number) {
    this.$nextTick(() => {
      this.notificationList = this.notificationList.filter((n) => Number(n.id) !== val)
    })
  }

  protected add() {
    this.fakeIndexCounter++
    this.notificationList.push({
      id: this.fakeIndexCounter,
      text: '...or did i meant PENIS?',
      icon: 'mood',
      color: 'black',
      dismissable: true,
      read: false,
    })
  }
}
